import { hyperdbTriggers } from 'hyperdb-utils';
import httpRequest from '../../../helpers/httpRequest';
import { APP_URL } from '../../../../config';
import * as config from '../../../../config';

const triggers = hyperdbTriggers({ config,
  namespace: 'RENTAL_RULESET',
  entryPoint: '/rental-rulesets',
  collectionName: 'daily_rental_rulesets',
  querySearchListing: [
    ['name', ['daily_rental_ruleset', ['id'] ]],
    { order: { id: 'asc' } }
  ],
  successMessageCreate: 'Rental ruleset created',
  successMessageUpdate: 'Rental ruleset updated',
  successMessageDelete: 'Rental ruleset deleted',
});

export default {
  ...triggers,
  copyModelForProperty(dispatch, getState, { propertyId, modelId }) {
    dispatch({ type: 'RENTAL_RULESET__SUBMIT_FORM' });
    const url = APP_URL + '/rental-rulesets/copy';
    return httpRequest('POST', url, { propertyId, modelId })
      .then(res => {
        const payload = { savedObject: res, successMessage: 'rental ruleset created' };
        dispatch({ type: 'RENTAL_RULESET__SUBMIT_FORM_SUCCESS', payload });
      })
      .catch(err => {
        dispatch({ type: 'RENTAL_RULESET__ERROR', payload: err });
      });
  },
  getCalendar(dispatch, getState, { propertyId, modelId, from, to }) {
    dispatch({ type: 'RENTAL_RULESET__GET_OBJECT' });
    const url = APP_URL + `/rental-rulesets/${modelId}/calendar?propertyId=${propertyId}&from=${from}&to=${to}`;
    return httpRequest('GET', url)
      .then(res => {
        const payload = res;
        triggers.setData(dispatch, getState, { calendar: res });
      })
      .catch(err => {
        dispatch({ type: 'RENTAL_RULESET__ERROR', payload: err });
      });
  }
};



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/triggers.js